import React from "react";
import { Outlet } from "react-router-dom";
import ProfileNavbar from "../../Component/ProfileNavbar";
import Header from "../../Component/Header/Header";
import Footer from "../../Component/Footer/Footer";

const Layout = () => {
  return (
    <div className="dashboard">
      <Header />
      <div className="dashRight">
        <ProfileNavbar />
        <Outlet />
         <Footer />
      </div>
    </div>
  );
};

export default Layout;
